<template>
  <form @submit.prevent="submit">
    <b-row>
      <b-col sm>
        <b-card :title="$t('managers.field_groups.account')">
          <fields ungrouped layout="vertical" />
        </b-card>
      </b-col>
      <b-col sm>
        <b-card :title="$t('account.admin_notifications')">
          <fields group="admin_notifications" layout="vertical" />
        </b-card>
      </b-col>
    </b-row>
    <b-card v-for="(label, group) in repeatGroups" :key="group" :title="label">
      <fields :group="group" layout="vertical" />
    </b-card>
    <div class="form-group">
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
      <b-button type="button" variant="light" class="ml-2" @click="cancel">
        {{ $t('general.cancel') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import omit from 'lodash-es/omit'
import { ResourceFormMixin } from 'stylemix-vue-admin'
import ManagersApi from './ManagersApi'

const resourceBase = 'managers'

export default {
  name: 'ManagerEdit',

  mixins: [ResourceFormMixin],

  data() {
    return {
      base: resourceBase,
      groups: {},
    }
  },

  computed: {
    repeatGroups() {
      return omit(this.groups, ['admin_notifications'])
    },
  },

  mounted() {
    this.loadForm().then(result => {
      this.groups = result.groups
    })
  },

  methods: {
    api() {
      return new ManagersApi()
    },

    submit() {
      this.save().then(result => {
        this.$toast.success(result.message)
      })
    },
  },
}
</script>
